import { Loader } from '../../components/Loader';
import { reloadDispositionOptions, reloadProspectInfoOptions } from '../../lib/redux/filters/options/options';
import { reloadAdminWrite, reloadAuthorizationInfoInitialState, reloadGroups, reloadTeam, reloadUser, reloadVisibleAccounts, reloadMultiDialerQuota } from '../../lib/redux/users/slice';
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { reloadCustomDefinitions } from '../../lib/redux/users/slice';
import { reloadSavedViews } from '../../lib/redux/views/slice';
import { RootState } from '../../store';

export const PrivateRoute: React.FC<{component: React.ComponentType<any>}> = ({ component: Component, ...rest }) => {
    // Use direct Redux selectors for loading logic to avoid circular dependencies with useUserData hook
    const authenticationInfo = useSelector((state: RootState) => state.authenticationInfo.value);
    const user = useSelector((state: RootState) => state.user.value);
    const userGroupsLoaded = useSelector((state: RootState) => state.userGroupInfo.hasLoaded);
    const adminWriteState = useSelector((state: RootState) => state.adminWrite.value);
    const visibleAccounts = useSelector((state: RootState) => state.visibleAccounts.value);
    const prospectInfoOptions = useSelector((state: RootState) => state.prospectInfoOptions.value);
    const dispositionOptions = useSelector((state: RootState) => state.dispositionOptions.value);
    const team = useSelector((state: RootState) => state.team.value);
    const customDefinitions = useSelector((state: RootState) => state.customDefinitions.value);
    const multiDialerQuota = useSelector((state: RootState) => state.multiDialerQuota.value);
    const savedViews = useSelector((state: RootState) => state.savedViews.value);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!authenticationInfo) reloadAuthorizationInfoInitialState(dispatch);
    }, [authenticationInfo, dispatch]);

    useEffect(() => {
        if (!user) reloadUser(dispatch);
    }, [user, dispatch]);

    useEffect(() => {
        if (!userGroupsLoaded) reloadGroups(dispatch);
    }, [userGroupsLoaded, dispatch]);

    useEffect(() => {
        if (adminWriteState === null) reloadAdminWrite(dispatch);
    }, [adminWriteState, dispatch]);

    useEffect(() => {
        if (visibleAccounts === null) reloadVisibleAccounts(dispatch);
    }, [visibleAccounts, dispatch]);

    useEffect(() => {
        if (prospectInfoOptions === null) reloadProspectInfoOptions(dispatch);
    }, [prospectInfoOptions, dispatch]);

    useEffect(() => {
        if (dispositionOptions === null) reloadDispositionOptions(dispatch);
    }, [dispositionOptions, dispatch]);

    useEffect(() => {
        if (team === null) reloadTeam(dispatch);
    }, [team, dispatch]);

    useEffect(() => {
        if (customDefinitions === null) reloadCustomDefinitions(dispatch);
    }, [customDefinitions, dispatch]);

    useEffect(() => {
        if (multiDialerQuota === null) reloadMultiDialerQuota(dispatch);
    }, [multiDialerQuota, dispatch]);

    useEffect(() => {
        if (savedViews === null) reloadSavedViews(dispatch);
    }, [savedViews, dispatch]);
    if (!authenticationInfo) return <Loader />;
    if (authenticationInfo && authenticationInfo.apiKey == null) {
        // Avoid redirecting to login if we're already on a login page
        if (window.location.pathname === '/login' || window.location.pathname.includes('/pages/login')) {
            return <Loader />;
        }
        const loginParams = new URLSearchParams({'returnTo': window.location.pathname + window.location.search})
        const email = new URLSearchParams(window.location.search).get('email')
        if (email !== null) {
            loginParams.set('email', email)
        }
        return <Navigate to={`/login?${loginParams.toString()}`} />
    }
    return <Component {...rest} />;
}
